import { SimpleForm, TextInput, useNotify, useRedirect, required, regex } from 'react-admin';
import { useFormContext } from 'react-hook-form';
import { useEffect } from 'react';
import CraftCreate from 'src/components/CraftCreate';
import CraftSimpleFormToolbar from 'src/components/CraftSimpleFormToolbar';
import useUnicityValidator from 'src/utils/useUnicityValidator';
import { Typography } from '@mui/material';

const ProgramKeyInput = () => {
  const { setValue, watch } = useFormContext();
  const name: string = watch('name');
  const value = (name || '').toLowerCase().replace(/ /g, '-');
  const validateKeyUnique = useUnicityValidator('programs', 'key');
  const noSpaces = regex(/^\S+$/, 'Must not contain spaces');

  useEffect(() => {
    setValue('key', value);
  }, [name, setValue]);

  return (
    <TextInput
      source="key"
      label="Program key"
      fullWidth
      value={value}
      helperText="Key cannot be changed after creation"
      validate={[required(), noSpaces, validateKeyUnique]}
    />
  );
};

export const PortalProgramsCreate = () => {
  const notify = useNotify();
  const redirect = useRedirect();

  const onSuccess = (data: { id: string | number }) => {
    notify('The program has been successfully created', { type: 'success' });
    redirect(`/programs/${data.id}`);
  };

  return (
    <CraftCreate mutationOptions={{ onSuccess }}>
      <SimpleForm toolbar={<CraftSimpleFormToolbar />}>
        <h2>Add a new program</h2>
        <Typography variant="body1" mb={3}>
          You will be able to add users after creating the program.
        </Typography>
        <TextInput source="name" label="Program name" fullWidth validate={required()} />
        <ProgramKeyInput />
      </SimpleForm>
    </CraftCreate>
  );
};
